import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';

import { CriticalTableDialogComponent, type CriticalTableDialogData } from './critical-table-dialog.component';

@Injectable()
export class CriticalTableDialogService extends AbstractDialogService<
  CriticalTableDialogData,
  void,
  typeof CriticalTableDialogComponent
> {
  readonly id = 'critical-table-dialog';
  protected readonly component = CriticalTableDialogComponent;

  override readonly options: DialogOptions = {
    cssClass: 'critical-table-dialog action-sheet-on-mobile',
    handle: false,
  };

  open(data: CriticalTableDialogData): Promise<void | undefined> {
    return this.openDialog({
      input: data,
      options: {
        componentProps: {
          result: data.result,
        },
      },
    });
  }
}
